import styled from 'styled-components';

import Button from 'components/shared/Button';
import StandardModal, { Actions } from 'components/shared/StandardModal';
import { BodySmall, BodySmallBold } from 'styles/typography';

type Props = {
  flagTitle: string;
  // What the flag is on for now, e.g. "2 users and the devs group". Enabling for everyone deletes it.
  removing?: string;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function EnableFlagModal({ flagTitle, removing, loading, onConfirm, onCancel }: Props) {
  return (
    <StandardModal title='Enable Feature Flag' onCancel={onCancel}>
      <Content>
        <BodySmallBold>Enable {flagTitle} for everyone?</BodySmallBold>
        <BodySmall>Users may still need the right configuration or permissions to see this feature.</BodySmall>
        {removing && (
          <BodySmall>
            This also removes {removing} it&apos;s turned on for now. If you turn it off for everyone later, it
            won&apos;t go back to them. You&apos;d need to add them again.
          </BodySmall>
        )}
        <Actions>
          <Button variant='ghost' onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={loading}>
            {loading ? 'Enabling...' : 'Enable for Everyone'}
          </Button>
        </Actions>
      </Content>
    </StandardModal>
  );
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
